var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsBasedModel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640.001,
    height: 434,
    viewBox: "0 0 640.001 434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640.001,
    height: 359.313,
    transform: "translate(-262.535)",
    fill: "#292929",
    stroke: "#3a3a3a",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-720 -2764)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 434,
    rx: 3,
    transform: "translate(720 2764)",
    fill: "#faf9ff"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1283.186 2867.125)",
    fill: "#292929",
    fontSize: 15,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -38.668,
    y: 0
  }, "Succession"), /*#__PURE__*/React.createElement("tspan", {
    x: -28.876,
    y: 16
  }, "planning")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(919.539 2953.693)",
    fill: "#292929",
    fontSize: 16,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Employee engagement"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "and retention")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1120 2863.293)",
    fill: "#292929",
    fontSize: 15,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.799,
    y: 0
  }, "Performance"), /*#__PURE__*/React.createElement("tspan", {
    x: -44.344,
    y: 16
  }, "Management")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1087.254 3035)",
    fill: "#292929",
    fontSize: 15,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Onboarding and"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "Upskilling")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(795 3131.843)",
    fill: "#292929",
    fontSize: 16,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.965,
    y: 0
  }, "Talent "), /*#__PURE__*/React.createElement("tspan", {
    x: -40.422,
    y: 20
  }, "Acquisition")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(982.535 2798.678)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171.239 14.646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3951.435,1150.811H3961.5v-66.266a44.156,44.156,0,0,0-44.151-44.153h-41.517a34.086,34.086,0,1,1,0-68.172h402.182a44.2,44.2,0,0,0,44.152-44.153v-1.612a44.2,44.2,0,0,0-44.152-44.153H4162.963a34.1,34.1,0,0,1,0-68.194h227.363c24.345,0,73.152-19.809,73.152-44.154V745.269a34.084,34.084,0,0,1,34.088-34.085h195.085V701.118H4497.566a44.151,44.151,0,0,0-44.154,44.151v24.687c0,18.8-44.291,34.086-63.084,34.087H4162.963a44.163,44.163,0,0,0,0,88.327h115.052a34.125,34.125,0,0,1,34.085,34.087v1.612a34.125,34.125,0,0,1-34.085,34.086H3875.834a44.153,44.153,0,1,0,0,88.305h41.517a34.084,34.084,0,0,1,34.084,34.084Z",
    transform: "translate(-4071.679 -701.118)",
    fill: "#d5befe"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M286.843,178.8h33.073l16.536,28.642-16.536,28.642H286.843l-16.536-28.642Z",
    transform: "translate(487.193 2871.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.554,178.3H320.2l16.825,29.142L320.2,236.586H286.554l-16.825-29.142Zm33.073,1h-32.5l-16.247,28.142,16.247,28.142h32.5l16.247-28.142Z",
    transform: "translate(487.193 2871.698)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776 3065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1021.143,318.108h0a12.124,12.124,0,0,1,1.367,24.17,12.3,12.3,0,0,1-1.379.078,12.124,12.124,0,0,1-1.352-24.172A12.321,12.321,0,0,1,1021.143,318.108Zm-.011,22.648a10.685,10.685,0,0,0,1.2-.068,10.524,10.524,0,0,0-1.187-20.98h0a10.7,10.7,0,0,0-1.184.066,10.524,10.524,0,0,0,1.173,20.982Z",
    transform: "translate(-1009.82 -318.908)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.4,348.69a4.026,4.026,0,0,1-2.6-.947h-.021l-.235-.234-6.47-6.469a.8.8,0,1,1,1.131-1.131l6.471,6.469a2.439,2.439,0,0,0,3.438.009l.009-.009a2.437,2.437,0,0,0,0-3.446l-6.47-6.468a.8.8,0,1,1,1.131-1.132l6.471,6.469a4.037,4.037,0,0,1,.013,5.7l-.015.015A4.025,4.025,0,0,1,1036.4,348.69Z",
    transform: "translate(-1010.241 -319.309)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.206 5.372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1027.181,340.468a.8.8,0,0,1-.8-.8v-1.029a5.23,5.23,0,0,0-5.216-5.215h-.025a5.193,5.193,0,0,0-5.189,5.162v1.082a.8.8,0,0,1-1.6,0v-1.086a6.8,6.8,0,0,1,6.786-6.758h.033a6.833,6.833,0,0,1,6.811,6.814v1.03A.8.8,0,0,1,1027.181,340.468Z",
    transform: "translate(-1015.152 -324.604)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.219,323.61h0a4.81,4.81,0,1,1-4.81,4.809A4.822,4.822,0,0,1,1021.22,323.61Zm0,8.019a3.21,3.21,0,1,0-3.209-3.21A3.213,3.213,0,0,0,1021.219,331.629Z",
    transform: "translate(-1015.201 -324.41)",
    fill: "#6b19ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12328.843,2578.712l-.92-.919,4.166-4.165-4.166-4.165.92-.919,5.084,5.085-.459.46Z",
    transform: "translate(-11419.835 505.86)",
    fill: "#240948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12332.548,2578.712l-5.084-5.084.459-.46,4.625-4.625.92.919-4.166,4.165,4.166,4.165Z",
    transform: "translate(-11358.892 425.796)",
    fill: "#240948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12328.843,2578.712l-.92-.919,4.166-4.165-4.166-4.165.92-.919,5.084,5.085-.459.46Z",
    transform: "translate(-11299.331 347.685)",
    fill: "#240948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.165,9.709-.919,4.625,4.165-.46,5.084.46.919,4.625,5.084,8.79Z",
    transform: "translate(1202.627 2857.25) rotate(90)",
    fill: "#240948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.843,178.8h33.073l16.536,28.642-16.536,28.642H286.843l-16.536-28.642Z",
    transform: "translate(740.191 2831.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.554,178.3H320.2l16.825,29.142L320.2,236.586H286.554l-16.825-29.142Zm33.073,1h-32.5l-16.247,28.142,16.247,28.142h32.5l16.247-28.142Z",
    transform: "translate(740.191 2831.698)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.843,178.8h33.073l16.536,28.642-16.536,28.642H286.843l-16.536-28.642Z",
    transform: "translate(574.191 2751.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.554,178.3H320.2l16.825,29.142L320.2,236.586H286.554l-16.825-29.142Zm33.073,1h-32.5l-16.247,28.142,16.247,28.142h32.5l16.247-28.142Z",
    transform: "translate(574.191 2751.305)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.843,178.8h33.073l16.536,28.642-16.536,28.642H286.843l-16.536-28.642Z",
    transform: "translate(816.193 2711.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.554,178.3H320.2l16.825,29.142L320.2,236.586H286.554l-16.825-29.142Zm33.073,1h-32.5l-16.247,28.142,16.247,28.142h32.5l16.247-28.142Z",
    transform: "translate(816.193 2711.697)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.843,178.8h33.073l16.536,28.642-16.536,28.642H286.843l-16.536-28.642Z",
    transform: "translate(980.248 2609.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.554,178.3H320.2l16.825,29.142L320.2,236.586H286.554l-16.825-29.142Zm33.073,1h-32.5l-16.247,28.142,16.247,28.142h32.5l16.247-28.142Z",
    transform: "translate(980.248 2609.924)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1029 3023.037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1034.812,495.3h-2.533a.7.7,0,0,1,0-1.4h2.533a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-1029.246 -477.832)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.819,498a.7.7,0,0,1-.7-.7c0-.574,0-1.089-.008-1.544-.018-2.084-.027-3.131.435-3.987.476-.882,1.352-1.356,2.944-2.218.553-.3,1.177-.637,1.923-1.064l.846-.787a1.259,1.259,0,0,1,1.571,0l.265.21v.218l1.24,1.688,1.365-1.857a1.172,1.172,0,0,1,1.6-.338,1.336,1.336,0,0,1,.111.08l.043.037.8.751c.751.424,1.38.762,1.938,1.06a8.8,8.8,0,0,1,2.735,1.835,4.38,4.38,0,0,1,.73,2.888.7.7,0,0,1-.687.713h-.013a.7.7,0,0,1-.7-.687c-.037-2.074-.139-2.129-2.726-3.515-.582-.312-1.243-.666-2.04-1.117l-.073-.041-.716-.67-2.37,3.226-2.371-3.226-.714.668-.071.04c-.792.454-1.474.823-2.023,1.12-1.4.757-2.1,1.138-2.378,1.652-.291.54-.283,1.524-.268,3.31,0,.458.008.977.008,1.556A.7.7,0,0,1,1020.819,498Z",
    transform: "translate(-1020.805 -477.896)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.49,489.479c-3.444,0-5.173-4.491-5.173-7.005a5.173,5.173,0,0,1,10.346-.017,8.353,8.353,0,0,1-2.093,5.611A4.218,4.218,0,0,1,1029.49,489.479Zm0-10.782a3.778,3.778,0,0,0-3.772,3.777,7.992,7.992,0,0,0,1.033,3.614,3.394,3.394,0,0,0,2.74,1.992,2.818,2.818,0,0,0,2.067-.977,7.027,7.027,0,0,0,1.707-4.594v-.04A3.778,3.778,0,0,0,1029.488,478.7Z",
    transform: "translate(-1021.067 -477.997)",
    fill: "#6b19ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1032.489,494.484h8.93v8.55l-.625.068a15.237,15.237,0,0,0-5.429,1.281c-.983.477-1.722.835-2.29,1.109-1.6.773-1.817.878-2.344,1.179a5.378,5.378,0,0,1-5.719.01l-11.5-5.832a2.183,2.183,0,0,1-1.034-2.055l0-.042a2.156,2.156,0,0,1,2.14-1.906h0a2.181,2.181,0,0,1,.253.015l.046.005.045.011,11.509,2.919a2.412,2.412,0,0,1,.533-.841l.005-.005,3.653-3.655A2.454,2.454,0,0,1,1032.489,494.484Zm7.531,1.4h-7.531a1.053,1.053,0,0,0-.788.356l-.029.031-3.664,3.665a1.01,1.01,0,0,0-.284.728l.032,1.164-1.084-.538-12-3.043a.755.755,0,0,0-.8.652v.018a.766.766,0,0,0,.347.723l11.483,5.822.028.018a3.978,3.978,0,0,0,4.262,0l.028-.017c.579-.331.827-.451,2.443-1.232.567-.274,1.3-.631,2.288-1.108a15.122,15.122,0,0,1,5.265-1.343Z",
    transform: "translate(-1013.172 -477.826)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.878,502.926a2.25,2.25,0,0,1-1.095-.284l-.085.087-.521-.573a2.326,2.326,0,0,1,.165-3.272l3.64-3.64a2.456,2.456,0,0,1,1.864-.811h8.886v4.633h-7.962a.29.29,0,0,0-.176.074l-3.224,3.22A2.244,2.244,0,0,1,1014.878,502.926Zm-.716-1.775.08.09a.848.848,0,0,0,1.193.075l.008-.007,3.184-3.183a1.689,1.689,0,0,1,1.1-.46h6.6v-1.833H1018.8a1.052,1.052,0,0,0-.789.355l-.03.032-3.7,3.694a.926.926,0,0,0-.128,1.239Z",
    transform: "translate(-999.594 -477.826)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.38,492.19h1.887a1.158,1.158,0,0,1,.265.037l.078.016h.042l.06.011a2.718,2.718,0,0,1,2.249,2.684v8.9a2.748,2.748,0,0,1-2.745,2.745h-1.887a2.719,2.719,0,0,1-2.672-2.192,1.591,1.591,0,0,1-.075-.578v-8.9a2.827,2.827,0,0,1,2.792-2.72Zm1.832,1.4h-1.823a1.428,1.428,0,0,0-1.407,1.362l0,8.929a.2.2,0,0,0,.013.086l.021.058.011.061a1.32,1.32,0,0,0,1.3,1.092h1.889a1.347,1.347,0,0,0,1.345-1.345v-8.9a1.32,1.32,0,0,0-1.053-1.3,1.93,1.93,0,0,1-.283-.047Z",
    transform: "translate(-979.765 -477.849)",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(864.531 2943.343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1231.891,306.287h.026a6.426,6.426,0,0,1,6.4,6.407v1a1.719,1.719,0,0,1-1.65,1.651h-9.514a1.718,1.718,0,0,1-1.651-1.651v-1.047a6.385,6.385,0,0,1,6.384-6.361Zm5.031,7.367V312.7a5.024,5.024,0,0,0-5.009-5.008h-.022a5,5,0,0,0-4.984,4.964v1a.314.314,0,0,0,.292.292h9.432A.314.314,0,0,0,1236.923,313.654Z",
    transform: "translate(-1226.207 -299.378)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.827,299.03h0a4.5,4.5,0,1,1-4.505,4.5A4.517,4.517,0,0,1,1231.828,299.03Zm0,7.609a3.1,3.1,0,1,0-3.1-3.105A3.109,3.109,0,0,0,1231.827,306.639Z",
    transform: "translate(-1226.119 -299.73)",
    fill: "#6b19ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.225 13.559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1248.319,306.287h.026a6.426,6.426,0,0,1,6.405,6.407v1a1.719,1.719,0,0,1-1.65,1.651h-9.514a1.719,1.719,0,0,1-1.651-1.651v-1.047a6.384,6.384,0,0,1,6.384-6.361Zm5.032,7.367V312.7a5.024,5.024,0,0,0-5.009-5.008h-.022a4.994,4.994,0,0,0-4.984,4.964v1a.314.314,0,0,0,.292.292h9.432A.314.314,0,0,0,1253.351,313.654Z",
    transform: "translate(-1242.635 -299.378)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.254,299.03h0a4.5,4.5,0,1,1-4.505,4.506A4.517,4.517,0,0,1,1248.255,299.03Zm0,7.609a3.1,3.1,0,1,0-3.107-3.1A3.108,3.108,0,0,0,1248.256,306.639Z",
    transform: "translate(-1242.546 -299.73)",
    fill: "#6b19ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0-.7H8.78a.7.7,0,0,1,.7.7V8.781a.7.7,0,0,1-.7.7H0a.7.7,0,0,1-.7-.7V0A.7.7,0,0,1,0-.7ZM8.08.7H.7V8.081H8.08Z",
    transform: "translate(1.318 0)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.671,296.28h-8.781a.7.7,0,0,1-.626-1.013l4.39-8.781a.7.7,0,0,1,1.252,0l4.39,8.781a.7.7,0,0,1-.626,1.013Zm-7.648-1.4h6.515l-3.258-6.515Z",
    transform: "translate(-1225.349 -286.799)",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1107 2905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.459-.7h3.29A1.161,1.161,0,0,1,4.908.459V8.008A1.161,1.161,0,0,1,3.749,9.167H.459A1.161,1.161,0,0,1-.7,8.008V.459A1.161,1.161,0,0,1,.459-.7ZM3.508.7H.7V7.767H3.508Z",
    transform: "translate(7.454 19.277)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.459-.7h3.29A1.161,1.161,0,0,1,4.908.459V11.292a1.161,1.161,0,0,1-1.159,1.159H.459A1.161,1.161,0,0,1-.7,11.292V.459A1.161,1.161,0,0,1,.459-.7ZM3.508.7H.7V11.051H3.508Z",
    transform: "translate(14.895 15.993)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.459-.7h3.29A1.161,1.161,0,0,1,4.908.459V13.816a1.161,1.161,0,0,1-1.159,1.159H.459A1.161,1.161,0,0,1-.7,13.816V.459A1.161,1.161,0,0,1,.459-.7ZM3.508.7H.7V13.575H3.508Z",
    transform: "translate(0 13.469)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.459-.7h3.29A1.161,1.161,0,0,1,4.908.459V18.147a1.161,1.161,0,0,1-1.159,1.159H.459A1.161,1.161,0,0,1-.7,18.147V.459A1.161,1.161,0,0,1,.459-.7ZM3.508.7H.7V17.907H3.508Z",
    transform: "translate(22.331 9.137)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.017,256.864l-7.255-7.256a.7.7,0,0,1,.99-.99l6.265,6.266,13.028-13.027a.7.7,0,0,1,.99.99Z",
    transform: "translate(-1125.24 -240.101)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.353,
    cy: 1.353,
    rx: 1.353,
    ry: 1.353,
    transform: "translate(0.78 6.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.353-.7A2.053,2.053,0,1,1-.7,1.353,2.056,2.056,0,0,1,1.353-.7Zm0,2.707A.653.653,0,1,0,.7,1.353.654.654,0,0,0,1.353,2.007Z",
    transform: "translate(0.78 6.43)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.353,
    cy: 1.353,
    rx: 1.353,
    ry: 1.353,
    transform: "translate(8.226 13.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.353-.7A2.053,2.053,0,1,1-.7,1.353,2.056,2.056,0,0,1,1.353-.7Zm0,2.707A.653.653,0,1,0,.7,1.353.654.654,0,0,0,1.353,2.007Z",
    transform: "translate(8.226 13.875)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.353,
    cy: 1.353,
    rx: 1.353,
    ry: 1.353,
    transform: "translate(15.645 7.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.353-.7A2.053,2.053,0,1,1-.7,1.353,2.056,2.056,0,0,1,1.353-.7Zm0,2.707A.653.653,0,1,0,.7,1.353.654.654,0,0,0,1.353,2.007Z",
    transform: "translate(15.645 7.107)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.353,
    cy: 1.353,
    rx: 1.353,
    ry: 1.353,
    transform: "translate(23.081 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.353-.7A2.053,2.053,0,1,1-.7,1.353,2.056,2.056,0,0,1,1.353-.7Zm0,2.707A.653.653,0,1,0,.7,1.353.654.654,0,0,0,1.353,2.007Z",
    transform: "translate(23.081 0)",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1268.641 2803.034)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.895,357.524h-.06a3.754,3.754,0,0,1-3.733-3.608c0-.009,0-.019,0-.028v-.979s0-.009,0-.013a3.694,3.694,0,0,1,3.747-3.625h.011a3.727,3.727,0,0,1,3.726,3.617c0,.007,0,.014,0,.021v.979s0,.009,0,.013a3.692,3.692,0,0,1-3.69,3.624Zm-2.394-3.652a2.356,2.356,0,0,0,2.345,2.252h.048a2.3,2.3,0,0,0,2.29-2.244v-.961a2.316,2.316,0,0,0-2.326-2.249h-.027a2.305,2.305,0,0,0-2.331,2.245Z",
    transform: "translate(-285.14 -349.97)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.295,371.222a4.21,4.21,0,0,1-3.742-3.69v-4.8q0-.016,0-.031a5.072,5.072,0,0,1,4.9-4.845h4.869v1.4h-4.835a3.689,3.689,0,0,0-3.539,3.492v4.779a2.908,2.908,0,0,0,2.342,2.29Z",
    transform: "translate(-285.253 -349.696)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.777,376.384h-1.4v-5.7a1.339,1.339,0,0,0-1.337-1.338h-3.7a.7.7,0,0,1-.7-.7v-6.53a.7.7,0,0,1,.7-.7h2.724a2.122,2.122,0,0,0,.774-.146l4.2-1.636a1.27,1.27,0,0,0,.6-1.4,1.161,1.161,0,0,0-.045-.148,1.268,1.268,0,0,0-1.634-.746l-4.693,1.754a3.525,3.525,0,0,1-1.238.224h-2.192v-1.4h2.192a2.129,2.129,0,0,0,.748-.135l4.693-1.754a2.668,2.668,0,0,1,3.435,1.564,2.536,2.536,0,0,1,.1.321,2.67,2.67,0,0,1-1.341,2.971.707.707,0,0,1-.075.034l-4.245,1.653a3.516,3.516,0,0,1-1.282.242H296.04v5.13h3a2.741,2.741,0,0,1,2.737,2.738Z",
    transform: "translate(-284.979 -349.759)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,381.249h-3.608a.7.7,0,0,1-.7-.7V362.608h1.4v17.241h2.208v-6.482a1.768,1.768,0,0,1,1.762-1.765H296.2a2.171,2.171,0,0,1,2.168,2.168v2.5h-1.4v-2.5A.769.769,0,0,0,296.2,373h-3.278a.366.366,0,0,0-.365.365v7.182A.7.7,0,0,1,291.86,381.249Z",
    transform: "translate(-285.157 -349.567)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.078-.7H12.006a.779.779,0,0,1,.778.778V3.5a.779.779,0,0,1-.778.778H.078A.779.779,0,0,1-.7,3.5V.078A.779.779,0,0,1,.078-.7ZM11.384.7H.7V2.882H11.384Z",
    transform: "translate(9.745 27.401)",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.345,3.6-.345,2.383,4.945-.609,5.634.609Z",
    transform: "translate(21.046 9.787)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.345,2.584-.345,1.366,3.147-.609,3.836.609Z",
    transform: "translate(21.394 5.36)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.345,1.673-.345.455,1.536-.609,2.225.609Z",
    transform: "translate(16.601 14.23)",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,359.212a.751.751,0,0,1-.544-.235l-.022-.024a.741.741,0,0,1-.173-.379l-.174-1.122a5.965,5.965,0,0,0-1.55-3.181l-1.118-1.19a.749.749,0,0,1,.03-1.051l.023-.021a.747.747,0,0,1,.406-.18h.014l.972-.093a5.958,5.958,0,0,0,4.381-2.6.747.747,0,0,1,1.012-.217l.036.023a.752.752,0,0,1,.306.487l.221,1.283a5.956,5.956,0,0,0,1.59,3.138l1.014,1.048a.747.747,0,0,1,.032,1.023.738.738,0,0,1-.454.245l-1.09.166a5.966,5.966,0,0,0-3.185,1.545l-1.216,1.138A.739.739,0,0,1,313.86,359.212Zm-1.655-6.126.213.227a7.358,7.358,0,0,1,1.9,3.832l.313-.293a7.359,7.359,0,0,1,3.778-1.881l-.145-.15a7.349,7.349,0,0,1-1.943-3.768A7.345,7.345,0,0,1,312.2,353.086Z",
    transform: "translate(-284.44 -349.504)",
    fill: "#6b19ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBasedModel);
export default __webpack_public_path__ + "static/media/skills-based-model.eb648c91548222c37877dfe48a50db31.svg";
export { ForwardRef as ReactComponent };